import React from 'react';
import { X, FileDown, Square, Mic } from 'lucide-react';

/**
 * ScriptViewer — fullscreen teleprompter to read a script while recording.
 * Props: title, lines, onClose, recording (bool), onStopRecord, downloadUrl
 */
export const ScriptViewer = ({ title, lines, onClose, recording = false, onStopRecord, downloadUrl = '/scripts-preparation-mentale.docx' }) => (
  <div className="fixed inset-0 z-[300] bg-slate-950/98 flex flex-col" data-testid="script-viewer">
    <div className="sticky top-0 flex items-center justify-between gap-2 px-4 pt-10 pb-3 bg-slate-950/90 backdrop-blur-md border-b border-white/10">
      <div className="flex items-center gap-2 min-w-0">
        {recording && <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse flex-shrink-0" />}
        <h3 className="text-white text-sm font-semibold truncate">{title}</h3>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <a href={downloadUrl} download
          className="px-3 py-2 rounded-full bg-sky-500/15 border border-sky-400/30 text-sky-300 text-xs font-medium flex items-center gap-1.5 hover:bg-sky-500/25"
          data-testid="script-download-word">
          <FileDown className="w-3.5 h-3.5" /> Word
        </a>
        <button onClick={onClose} className="p-2 rounded-full bg-white/10 text-white hover:bg-white/20"
          data-testid="script-viewer-close" aria-label="Fermer">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>

    <div className="flex-1 overflow-y-auto px-5 py-6">
      <div className="max-w-xl mx-auto space-y-6 pb-32">
        {lines.map((line, i) => (
          <p key={i} className="text-white/90 text-lg sm:text-xl leading-relaxed" data-testid={`script-line-${i}`}>
            {line}
          </p>
        ))}
      </div>
    </div>

    {recording && (
      <div className="sticky bottom-0 px-4 py-4 bg-slate-950/95 backdrop-blur-md border-t border-white/10 flex items-center justify-center gap-3">
        <span className="text-red-300 text-xs flex items-center gap-1.5"><Mic className="w-3.5 h-3.5 animate-pulse" /> Enregistrement en cours…</span>
        <button onClick={onStopRecord}
          className="px-5 py-2.5 rounded-full bg-red-500/80 hover:bg-red-500 text-white text-sm font-semibold flex items-center gap-2"
          data-testid="script-viewer-stop-record">
          <Square className="w-4 h-4" /> Arrêter et sauvegarder
        </button>
      </div>
    )}
  </div>
);

export default ScriptViewer;
